import React, { useState } from 'react';
import { Button, TextField, Snackbar, Alert } from '@mui/material';

const CopyToClipboardButton = (props) => {
  const [text, setText] = useState(props.text)
  const [open, setOpen] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setOpen(true)
      })
      .catch((err) => {
        console.error('Failed to copy: ', err)
      })
  }

  const handleClose = () => {
    setOpen(false)
  };

  return (
    <div className='text-center'>
      <Button variant="contained" color="primary" onClick={handleCopy}>
        コピー
      </Button>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CopyToClipboardButton;
